import { db, useLive, type TripRecord } from './db';
import type { StopDto } from './types';

/** Курсовете, които са в ръцете на шофьора в момента. */
const ACTIVE_STATUSES = ['dispatched', 'accepted', 'in_progress'] as const;

export function useActiveTrips(): TripRecord[] {
  return useLive(
    async () => {
      const trips = await db.trips.where('status').anyOf(...ACTIVE_STATUSES).toArray();
      return trips.sort(
        (a, b) => Date.parse(a.plannedStartAt ?? '') - Date.parse(b.plannedStartAt ?? ''),
      );
    },
    [],
    [],
  );
}

export function useTrip(tripId: string | null): TripRecord | null {
  return useLive(
    async () => (tripId ? ((await db.trips.get(tripId)) ?? null) : null),
    [tripId],
    null,
  );
}

export function useStops(tripId: string | null): StopDto[] {
  return useLive(
    async () => {
      if (!tripId) return [];
      const stops = await db.stops.where('tripId').equals(tripId).toArray();
      return stops.sort((a, b) => a.sequence - b.sequence);
    },
    [tripId],
    [],
  );
}

export function useStop(stopId: string | null): StopDto | null {
  return useLive(
    async () => (stopId ? ((await db.stops.get(stopId)) ?? null) : null),
    [stopId],
    null,
  );
}

/** Следващият адрес: първият незавършен по ред. Това е „днешната задача". */
export function nextStopOf(stops: StopDto[]): StopDto | null {
  return stops.find((stop) => stop.status !== 'completed' && stop.status !== 'failed') ?? null;
}
